import { create } from "zustand";
import { httpRequest } from "../utils/httpRequest";
import { message } from "antd";
// import { dateOptions } from "../constants/date";
// import dayjs from "dayjs";
const initialState = {
  loading: false,
  success: false,
  error: false,
  data: null,
  errorData: null,
};

export const logout = () => {
  localStorage.removeItem("cars_token");
  window.location.reload();
};

export const useLangStore = create((set) => ({
  lang: "RU",
  changeLang: (l) => {
    set({ lang: l });
  },
}));

// export const useDateRange = create((set) => ({
//   dateRange: dateOptions[3]?.range,
//   setDateRange: (date) => {
//     set({ dateRange: date });
//   },
// }));

// export const useDateMonth = create((set) => ({
//   dateMonth: dayjs().format("MM/YYYY"),
//   range: {
//     from: null,
//     to: null,
//   },
//   setDateMonth: (dateMonth) => {
//     set({ dateMonth });
//   },
//   setDateMonthRange: ({ from, to }) => {
//     set({ range: { from, to } });
//   },
// }));

const request = (props, option) =>
  create((set, get) => ({
    ...initialState,
    execute: (p) => {
      if (props.method === "GET" && !p?.force && Boolean(get().data)) {
        return;
      }
      set({ ...initialState, loading: true });

      let data;
      if (props?.data) {
        data = props?.data;
      }
      if (p?.data) {
        data = p?.data;
      }

      httpRequest({
        //  ...props, data: p?.data, params: p?.params
        ...props,
        data,
        // data: { ...props?.data, ...p?.data },
        params: { ...props?.params, ...p?.params },
      })
        .then((res) => {
          set({ ...initialState, success: true, data: res?.data });
          p?.onSuccess?.(res);
          option?.onSuccess?.(res);
        })
        .catch((err) => {
          set({ ...initialState, error: true, errorData: err });
          p?.onError?.(err);
          option?.onError?.(err);
          console.log("RequestError: ", err);
          if (!p?.onError && !option?.onError) {
            const d = err?.response?.data;
            message.error(typeof d === "object" ? JSON.stringify(d) : d);
          }
        })
        .finally(() => {
          p?.onFinal?.();
          option?.onFinal?.();
        });
    },
    clean: () => {
      set(initialState);
    },
  }));

const requestList = (props, option) =>
  create((set, get) => ({
    ...initialState,
    execute: (p) => {
      if (props.method === "GET" && !p?.force && Boolean(get().data)) {
        return;
      }
      set({ ...initialState, data: get().data, loading: true });
      httpRequest({
        ...props,
        data: { ...props?.data, ...p?.data },
        params: { ...props?.params, ...p?.params },
      })
        .then((res) => {
          set({ ...initialState, success: true, data: res.data });
          p?.onSuccess?.(res);
          option?.onSuccess?.(res);
        })
        .catch((err) => {
          set({ ...initialState, error: true, errorData: err });
          p?.onError?.(err);
          option?.onError?.(err);
          console.log("RequestError: ", err);
        })
        .finally(() => {
          p?.onFinal?.();
          option?.onFinal?.();
        });
    },
    clean: () => {
      set(initialState);
    },
  }));

export const useLogin = request({
  method: "POST",
  path: "auth/login",
});

export const useUploadFile = request({
  method: "POST",
  path: "file",
});

export const useMe = request({
  method: "GET",
  path: "user/me",
});

export const useEditMe = request(
  {
    method: "PUT",
    path: "user/me",
  },
  {
    onSuccess: () => {
      useMe.getState().execute({ force: true });
    },
  }
);

export const useCars = request({
  method: "GET",
  path: "cars",
  params: { type: "active" },
});

export const useSoldCars = request({
  method: "GET",
  path: "cars",
  params: { type: "sold" },
});

export const useCar = request({
  method: "GET",
  path: "cars/single",
});

export const useAddCars = request(
  {
    method: "POST",
    path: "cars",
  },
  {
    onSuccess: () => {
      useCars.getState().execute({ force: true });
    },
  }
);

export const useEditCar = request(
  {
    method: "PUT",
    path: "cars",
  }
  // {
  //   onSuccess: () => {
  //     useCars.getState().execute({ force: true });
  //   },
  // }
);

export const useDeleteCar = request(
  {
    method: "DELETE",
    path: "cars",
  },
  {
    onSuccess: () => {
      useCars.getState().execute({ force: true });
    },
  }
);

export const useFinances = request({
  method: "GET",
  path: "finance",
});

export const useFinanceReport = request({
  method: "GET",
  path: "finance/report",
});

export const useFinance = request({
  method: "GET",
  path: "finance/single",
});

export const useAddFinance = request(
  {
    method: "POST",
    path: "finance",
  }
  // {
  //   onSuccess: () => {
  //     useFinances.getState().execute({ force: true });
  //   },
  // }
);
export const useDeleteFinance = request({
  method: "DELETE",
  path: "finance",
});
